"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _overlay = require("@alicd/next/lib/overlay");

var _overlay2 = _interopRequireDefault(_overlay);

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _NextExpand = require("./NextExpand");

var _NextExpand2 = _interopRequireDefault(_NextExpand);

var _util = require("./util");

var _renderFromData = require("./render-from-data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ___child____siblings___ = void 0;

function renderItemCollapsed(item, self) {
    (0, _util.validateChildComponentType)(item);
    return _react2.default.cloneElement(item, {
        collapsed: self.props.collapsed,
        eventKey: item.key,
        level: self.props.level + 1,
        onOverlayVisibleChange: self.handleChildrenOverlayVisibleChange,
        onSelectOps: self.props.onSelectOps,
        selectedKeysSet: self.props.selectedKeysSet,
        itemsChild: self.props.itemsChild,
        dataRenderCallback: (0, _util.propagateFunctionProp)(item.props.dataRenderCallback, self.props.dataRenderCallback),
        itemOnClick: (0, _util.propagateFunctionProp)(item.props.itemOnClick, self.props.itemOnClick)
    });
}

function renderItemExpanded(item, props) {
    (0, _util.validateChildComponentType)(item);
    return _react2.default.cloneElement(item, {
        collapsed: props.collapsed,
        openKeys: props.openKeys,
        onOpen: props.onOpen,
        eventKey: item.key,
        opened: props.openKeysSet.has(item.key),
        openKeysSet: props.openKeysSet,
        level: props.level + 1,
        onSelectOps: props.onSelectOps,
        selectedKeysSet: props.selectedKeysSet,
        itemsChild: props.itemsChild,
        dataRenderCallback: (0, _util.propagateFunctionProp)(item.props.dataRenderCallback, props.dataRenderCallback),
        itemOnClick: (0, _util.propagateFunctionProp)(item.props.itemOnClick, props.itemOnClick)
    });
}

var Item = function (_React$Component) {
    (0, _inherits3.default)(Item, _React$Component);

    function Item(props) {
        (0, _classCallCheck3.default)(this, Item);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

        _this.state = {
            collapsedChildrenVisible: false,
            mouseOverMyHead: false,
            mouseOverOverlay: false
        };

        _this.handleVisibleChange = _this.handleVisibleChange.bind(_this);
        _this.handleChildrenOverlayVisibleChange = _this.handleChildrenOverlayVisibleChange.bind(_this);
        _this.handleMouseEnterHead = _this.handleMouseEnterHead.bind(_this);
        _this.handleMouseLeaveHead = _this.handleMouseLeaveHead.bind(_this);
        _this.handleMouseEnterOverlay = _this.handleMouseEnterOverlay.bind(_this);
        _this.handleMouseLeaveOverlay = _this.handleMouseLeaveOverlay.bind(_this);

        _this.renderDataChildren = _renderFromData.renderDataChildren.bind(_this);

        // TODO: filter childrenVisibleMap for removed children with itemsChild set
        //  when updating
        _this.childrenVisibleMap = {};

        _this.inExpandAnim = false;
        _this.inExpandAnimTimer = null;
        return _this;
    }

    (0, _createClass3.default)(Item, [{
        key: "handleClick",
        value: function handleClick(e) {
            var _this2 = this;

            var me = this;
            setTimeout(function () {
                if (!_this2.props.collapsed) {
                    if (!_this2.inExpandAnim) {
                        if (!_this2.props.opened) {
                            // this.props.openKeys.map((item, index)=>{
                            //     if(___child____siblings___ && ___child____siblings___.indexOf(item) > -1) {
                            //         this.props.openKeys.splice(index, 1);
                            //     }
                            // });
                            _this2.props.onOpen(_this2.props.openKeys.concat([_this2.props.eventKey]));
                        } else {
                            _this2.props.onOpen(_this2.props.openKeys.filter(function (k) {
                                return k != _this2.props.eventKey;
                            }));
                        }
                        _this2.inExpandAnim = true;
                        if (_this2.inExpandAnimTimer) {
                            clearTimeout(_this2.inExpandAnimTimer);
                        }
                        _this2.inExpandAnimTimer = setTimeout(function () {
                            _this2.inExpandAnim = false;
                            _this2.inExpandAnimTimer = null;
                        }, 256);
                    }
                }
                if (_this2.isSelectable()) {
                    _this2.props.onSelectOps(_this2.props.eventKey, _this2);
                }
                _this2.props.dataOnClick && _this2.props.dataOnClick.call(_this2, _this2.props.dataNode);
                _this2.props.onClick && _this2.props.onClick(e);
            }, 20);
        }
    }, {
        key: "handleVisibleChange",
        value: function handleVisibleChange(visible) {
            var _this3 = this;

            this.props.onOverlayVisibleChange && this.props.onOverlayVisibleChange(visible, this);

            if (!visible) {
                var childOverlayKeys = Array.prototype.concat.apply([], _react2.default.Children.map(this.props.children, function (c) {
                    if (!_react2.default.Children.count(c.props.children)) {
                        return [];
                    } else {
                        return [c.key];
                    }
                }));

                var dataChildren = (0, _renderFromData.recurseRenderData)(this.props.dataSource || this.props.dataNode && this.props.dataNode.children, this.props.dataRenderCallback);
                if (Array.isArray(dataChildren)) {
                    childOverlayKeys = Array.prototype.concat.apply(childOverlayKeys, dataChildren.map(function (c) {
                        if (!_react2.default.Children.count(c.props.children)) {
                            return [];
                        } else {
                            return [c.key];
                        }
                    }));
                }

                if (childOverlayKeys.map(function (k) {
                    return !!_this3.childrenVisibleMap[k];
                }).some(function (v) {
                    return !!v;
                })) {
                    return;
                }
            }

            this.setState({ collapsedChildrenVisible: visible });
        }
    }, {
        key: "handleChildrenOverlayVisibleChange",
        value: function handleChildrenOverlayVisibleChange(visible, self) {
            this.childrenVisibleMap[self.props.eventKey] = visible;
            this.props.onOverlayVisibleChange && this.props.onOverlayVisibleChange(visible, self);
            if (!this.state.mouseOverOverlay && !(0, _values2.default)(this.childrenVisibleMap).some(function (x) {
                return x;
            })) {
                this.setState({ collapsedChildrenVisible: false });
            }
            // if (!visible) {
            //     // try close
            //     this.handleVisibleChange(false)
            // }
        }
    }, {
        key: "handleMouseEnterHead",
        value: function handleMouseEnterHead(e) {
            var _this4 = this;

            var t = e.currentTarget;
            var CLASSNAME = "cn-navfold-item-head-mouseover";
            this.setState({ mouseOverMyHead: true }, function () {
                setTimeout(function () {
                    if (_this4.state.mouseOverMyHead) {
                        t.classList.add(CLASSNAME);
                    }
                }, 66);
            });
        }
    }, {
        key: "handleMouseLeaveHead",
        value: function handleMouseLeaveHead(e) {
            var t = e.currentTarget;
            var CLASSNAME = "cn-navfold-item-head-mouseleft";
            this.setState({ mouseOverMyHead: false });
            if (t.classList.contains("cn-navfold-item-head-mouseover")) {
                t.classList.add(CLASSNAME);
                setTimeout(function () {
                    t.classList.remove(CLASSNAME);
                    t.classList.remove("cn-navfold-item-head-mouseover");
                }, 250);
            }
        }
    }, {
        key: "handleMouseEnterOverlay",
        value: function handleMouseEnterOverlay(e) {
            this.setState({ mouseOverOverlay: true });
        }
    }, {
        key: "handleMouseLeaveOverlay",
        value: function handleMouseLeaveOverlay(e) {
            this.setState({ mouseOverOverlay: false });
        }
    }, {
        key: "isSelected",
        value: function isSelected() {
            if (typeof this.props.selected === "boolean") {
                return this.props.selected;
            }
            return this.props.selectedKeysSet.has(this.props.eventKey);
        }
    }, {
        key: "isSelectable",
        value: function isSelectable() {
            if (typeof this.props.selectable === "boolean") {
                return this.props.selectable;
            }
            return !this.hasFallen();
        }

        // means "has child" ...

    }, {
        key: "hasFallen",
        value: function hasFallen() {
            return _react2.default.Children.count(this.props.children) >= 1 || Array.isArray(this.props.dataSource) && this.props.dataSource.length > 0 || this.props.dataNode && Array.isArray(this.props.dataNode.children) && this.props.dataNode.children.length > 0;
        }
    }, {
        key: "getTitleText",
        value: function getTitleText(props) {
            switch ((0, _typeof3.default)(props.title)) {
                case "string":
                    return props.title;
                case "object":
                    {
                        if (props.title.type == "a") {
                            var children = props.title.props.children;
                            if (_react2.default.Children.count(children) >= 1) {
                                var first = _react2.default.Children.toArray(children)[0];
                                if (typeof first == "string") {
                                    return first;
                                }
                            }
                        }
                        return "";
                    }
                default:
                    return "";
            }
        }
    }, {
        key: "getTextIcon",
        value: function getTextIcon(props) {
            switch ((0, _typeof3.default)(props.textIcon)) {
                case "boolean":
                    {
                        if (props.textIcon) {
                            var titleText = this.getTitleText(props);
                            if (titleText) {
                                return titleText[0].toLocaleUpperCase();
                            }
                        }
                        return "";
                    }
                case "string":
                    return props.textIcon;
                default:
                    return "";
            }
        }
    }, {
        key: "renderIcon",
        value: function renderIcon() {
            var imageT = (0, _typeof3.default)(this.props.image);
            switch (imageT) {
                case "string":
                    return _react2.default.createElement("img", { className: "navfold-img", src: this.props.image });
                case "object":
                    return this.props.image;
                default:
                    {
                        switch ((0, _typeof3.default)(this.props.icon)) {
                            case "string":
                                return _react2.default.createElement(_icon2.default, { type: this.props.icon, size: "small" });
                            case "object":
                                return this.props.icon;
                            default:
                                {
                                    var textIcon = this.getTextIcon(this.props);
                                    if (textIcon) {
                                        return _react2.default.createElement(
                                            "span",
                                            { className: "cn-navfold-icon-texticon" },
                                            textIcon,
                                            _react2.default.createElement("span", { className: "cn-navfold-icon-texticon-locator" })
                                        );
                                    } else {
                                        return _react2.default.createElement("div", { className: "cn-navfold-icon-placeholder" });
                                    }
                                }
                        }
                    }
            }
        }
    }, {
        key: "renderNavIcon",
        value: function renderNavIcon() {
            if (!this.hasFallen()) {
                return null;
            }
            return _react2.default.createElement(_icon2.default, {
                className: (0, _classnames2.default)("cn-navfold-item-arrow", {
                    "cn-navfold-item-arrow-active": this.props.opened,
                    "cn-navfold-item-arrow-rotate": this.props.opened && !this.props.collapsed
                }),
                type: "arrow-right",
                size: this.props.collapsed ? "large" : "medium"
            });
        }
    }, {
        key: "onClickChild",
        value: function onClickChild(e) {
            e.stopPropagation();
            ___child____siblings___ = e.currentTarget.getAttribute('data-sibling-keys') ? JSON.parse(e.currentTarget.getAttribute('data-sibling-keys')) : [];
        }
    }, {
        key: "renderChildrenExpanded",
        value: function renderChildrenExpanded() {
            var _this5 = this;

            if (!this.props.opened || !this.hasFallen()) {
                return null;
            }
            var list = _react2.default.Children.map(this.props.children, function (item) {
                return item.key;
            });
            return _react2.default.createElement(
                "div",
                { className: "cn-navfold-item-child", "data-sibling-keys": (0, _stringify2.default)(list), onClick: this.onClickChild.bind(this) },
                _react2.default.Children.map(this.renderDataChildren(), function (n) {
                    return renderItemExpanded(n, _this5.props);
                }),
                _react2.default.Children.map(this.props.children, function (n) {
                    return renderItemExpanded(n, _this5.props);
                })
            );
        }
    }, {
        key: "renderChildrenCollapsed",
        value: function renderChildrenCollapsed() {
            var _this6 = this;

            return _react2.default.createElement(
                "div",
                {
                    className: "cn-navfold-item-child-collapsed",
                    onMouseEnter: this.handleMouseEnterOverlay,
                    onMouseLeave: this.handleMouseLeaveOverlay
                },
                (0, _util.showIf)(this.props.level == 0, function () {
                    return _react2.default.createElement(
                        "div",
                        { className: "cn-navfold-item-child-collapsed-first-title" },
                        _this6.props.title
                    );
                }),
                _react2.default.createElement(
                    "div",
                    { className: "cn-navfold-item-child-collapsed-children" },
                    _react2.default.Children.map(this.renderDataChildren(), function (n) {
                        return renderItemCollapsed(n, _this6);
                    }),
                    _react2.default.Children.map(this.props.children, function (n) {
                        return renderItemCollapsed(n, _this6);
                    })
                )
            );
        }
    }, {
        key: "renderCollapsedTrigger",
        value: function renderCollapsedTrigger() {
            var _this7 = this;

            return _react2.default.createElement(
                "div",
                {
                    className: (0, _classnames2.default)("cn-navfold-item", {
                        "cn-navfold-item-selected": this.isSelected(),
                        "cn-navfold-item-expanded": this.props.opened
                    })
                },
                _react2.default.createElement(
                    "div",
                    { className: 'cn-navfold-item-head ' + (this.props.opened && !this.props.children ? 'opened-item' : ''), onClick: this.handleClick.bind(this) },
                    (0, _util.showIf)(this.props.level == 0, function () {
                        return _react2.default.createElement(
                            "div",
                            { className: "cn-navfold-item-icon" },
                            !_this7.hasFallen() ? _react2.default.createElement(
                                _balloon2.default,
                                { className: "slider-nav-balloon-title", delay: 200, closable: false, align: "r", triggerType: "hover", trigger: _this7.renderIcon() },
                                _this7.props.title
                            ) : _this7.renderIcon()
                        );
                    }),
                    _react2.default.createElement("div", { className: "cn-navfold-item-collapsed-placeholder" }),
                    (0, _util.showIf)(this.props.level >= 1, function () {
                        return _react2.default.createElement(
                            "div",
                            { className: "cn-navfold-title" },
                            _this7.props.title,
                            _this7.props.level !== 0 ? _react2.default.createElement("div", { className: "cn-navfold-deco-pt cn-rdl-deco-left cn-rdl-deco-center" }) : null
                        );
                    }),
                    (0, _util.showIf)(this.props.level >= 1, function () {
                        return _this7.renderNavIcon();
                    })
                )
            );
        }
    }, {
        key: "renderCollapsed",
        value: function renderCollapsed() {
            if (!this.hasFallen()) {
                return this.renderCollapsedTrigger();
            }
            return _react2.default.createElement(
                _overlay2.default.Popup,
                {
                    trigger: this.renderCollapsedTrigger(),
                    triggerType: "hover",
                    align: "tl tr",
                    visible: this.state.collapsedChildrenVisible,
                    onVisibleChange: this.handleVisibleChange
                },
                this.renderChildrenCollapsed()
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this8 = this;

            if (this.props.collapsed) {
                return this.renderCollapsed();
            }
            return _react2.default.createElement(
                "div",
                {
                    className: (0, _classnames2.default)("cn-navfold-item", {
                        "cn-navfold-item-selected": this.isSelected(),
                        "cn-navfold-item-expanded": this.props.opened
                    })
                },
                _react2.default.createElement(
                    "div",
                    {
                        className: 'cn-navfold-item-head ' + (this.props.opened && this.hasFallen() ? 'opened-item' : ''),
                        onClick: this.handleClick.bind(this),
                        onMouseEnter: this.handleMouseEnterHead,
                        onMouseLeave: this.handleMouseLeaveHead
                    },
                    (0, _util.showIf)(this.props.level == 0, function () {
                        return _react2.default.createElement(
                            "div",
                            { className: "cn-navfold-item-icon" },
                            _this8.renderIcon()
                        );
                    }),
                    (0, _util.showIf)(!this.props.collapsed || this.props.level >= 1, function () {
                        return _react2.default.createElement(
                            "div",
                            { className: "cn-navfold-title" },
                            _this8.props.title,
                            _this8.props.level !== 0 ? _react2.default.createElement("div", { className: "cn-navfold-deco-pt cn-rdl-deco-left cn-rdl-deco-center" }) : null
                        );
                    }),
                    this.renderNavIcon()
                ),
                _react2.default.createElement(
                    _NextExpand2.default,
                    null,
                    this.renderChildrenExpanded()
                )
            );
        }
    }]);
    return Item;
}(_react2.default.Component);

Item.propTypes = {
    title: _propTypes2.default.node,
    icon: _propTypes2.default.string,
    selectable: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    eventKey: _propTypes2.default.string,
    onOpen: _propTypes2.default.func,
    opened: _propTypes2.default.bool,
    level: _propTypes2.default.number,
    collapsed: _propTypes2.default.bool,
    selected: _propTypes2.default.bool,

    openKeysSet: _propTypes2.default.object,
    onOverlayVisibleChange: _propTypes2.default.func,
    openKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    selectedKeysSet: _propTypes2.default.object,
    onSelectOps: _propTypes2.default.func,
    image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    itemsChild: _propTypes2.default.object,
    textIcon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),

    dataSource: _propTypes2.default.arrayOf(_propTypes2.default.object),
    dataRenderCallback: _propTypes2.default.func,
    itemOnClick: _propTypes2.default.func,
    dataNode: _propTypes2.default.object,
    dataOnClick: _propTypes2.default.func
};
Item.defaultProps = {};
exports.default = Item;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/Item.js
// module id = 110
// module chunks = 0